import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import ISubjects from '../@types/ISubjects';

interface SubjectsContextProviderProps {
  children: ReactNode
}

const SubjectsContext = createContext<ISubjects[]>([]);

export const useSubjectsContext = () => useContext(SubjectsContext);

export function SubjectsContextProvider({ children }: SubjectsContextProviderProps) {
  const [data, setData] = useState<ISubjects[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('content/html/subjects.json');
      const data = await response.json();
      setData(data.filter((subject: ISubjects) => subject !== null));
    };

    fetchData();
  }, []);

  return (
    <SubjectsContext.Provider value={data}>
      {children}
    </SubjectsContext.Provider>
  );
}
